<!-- Container-fluid starts-->
<div class="container-fluid">
  <!-- lista plików  -->
  <div class="row">
    <div class="col-lg-5">
        <div class="card">
          <div class="card-body custom-datatable">
              <ngx-datatable
              class='bootstrap'
              [rows]="contentData"
              [columnMode]="ColumnMode.flex"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="'auto'"
              [limit]="page.size"
              [count]="page.totalElements"
              [offset]="page.pageNumber"
              [externalPaging]="true"
              (page)="setPage($event)"
              [selected]="selected"
              [selectionType]="SelectionType.single"
              (select)="onSelect($event)"
            >
            <ngx-datatable-column name="lockerName" [flexGrow]="2">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Content locker</span>
               </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.lockerName }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Date" [flexGrow]="1">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Date</span>
               </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.creationDateUtc | date:'d/MM/yyyy H:mm' }}
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
          </div>
        </div>
    </div>

    <div class="col-lg-7">
      <div class="card">
        <div class="card-header">
          <h5>Integration</h5>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label for="exampleFormControlInput1">Add this script to your head section</label><br>
            <code>{{integ1}}</code>
          </div>
        <div class="form-group">
            <label for="exampleFormControlInput1">As link</label><br>
            <code>{{integ2}}</code>
        </div>
        <div class="form-group">
            <label for="exampleFormControlInput1">JavaScript Function (1)</label><br>
            <code>{{integ3}}</code>
        </div>
        <div class="form-group">
          <label for="exampleFormControlInput1">JavaScript Function (2)</label><br>
          <code>{{integ4}}</code><br>
          <small>* definition of <code>your_blocked_content_name</code> - here you can define your own name, should be a single string</small>
      </div>
        </div>
        <div class="card-footer btn-showcase">
          <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="edit selected locker" (click)="onEdit()">
              Edit</button>
          <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="delete selected locker" (click)="onDelete()">
              Delete</button>
          <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="add new locker" (click)="onNew()">
            <i class="fa fa-plus" aria-hidden="true"></i>Add</button>
          </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
